import { mutatorAction } from 'satcheljs';
import getStore from '../store/store';
import { AccountProviderType } from 'owa-accounts-store';

/**
 * Sets the selected account provider
 */
export default mutatorAction('setSelectedAccountProvider', function (
    accountProvider: AccountProviderType
) {
    getStore().selectedAccountProvider = accountProvider;
});
